import React from 'react';
import OverlayFrame from './OverlayFrame';
import AbstractCameraLostOverlay, {
  abstractMapStateToProps
} from './AbstractCameraLostOverlay';
import { translate } from 'store/modules/base/i18n';
import { connect } from 'store/modules/base/redux';

/**
 * Implements a React Component for camera lost overlay. Shown when the outbound
 * camera feed is lost. Shows options to either reset permissions or reload the
 * page. Also starts a countdown to check if the conference can be reloaded automatically.
 */
class CameraLostOverlay extends AbstractCameraLostOverlay {
  /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   * @returns {ReactElement}
   */
  render() {
    const { visible, t } = this.props;
    const { message, title } = this.state;

    if (!visible) {
      return (
        <OverlayFrame
          isLightOverlay={false}
          onClick={() => this.startIdleTimer()}
        />
      );
    }

    return (
      <OverlayFrame
        isLightOverlay={false}
        onClick={() => this.startIdleTimer()}>
        <div
          aria-describedby="reload_overlay_text"
          aria-labelledby="reload_overlay_title"
          className="inlay"
          role="dialog">
          <span
            className="reload_overlay_title"
            id="reload_overlay_title"
            role="heading">
            {t(title)}
          </span>
          <span className="reload_overlay_text" id="reload_overlay_text">
            {t(message)}
          </span>
          {this._renderCameraPermissions()}
          {this._renderProgressBar()}
          {this._renderReloadButton()}
        </div>
      </OverlayFrame>
    );
  }
}

export default translate(connect(abstractMapStateToProps)(CameraLostOverlay));
